import styled from 'styled-components';
import { grayLighter } from '@bufferapp/ui/style/colors';

export const Layout = styled.section`
  background-color: ${grayLighter};
  padding: 24px 0 0 0;
  flex: auto;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1980px;
  align-items: center;
  position: relative;
`;
